import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../i18n';

export const APP_LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'ta', label: 'தமிழ்' },
  { code: 'ml', label: 'മലയാളം' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'kn', label: 'ಕನ್ನಡ' },
  { code: 'te', label: 'తెలుగు' }
];

/** Language picker shared by the drawer, login and settings screens. */
export default function LanguageChips({ style }: { style?: object }) {
  const { i18n } = useTranslation();
  return (
    <View style={[styles.row, style]}>
      {APP_LANGUAGES.map((lang) => {
        const selected = (i18n.language || 'en').startsWith(lang.code);
        return (
          <TouchableOpacity
            key={lang.code}
            onPress={() => changeLanguage(lang.code)}
            style={[styles.chip, selected && styles.chipActive]}
          >
            <Text style={[styles.text, selected && styles.textActive]}>{lang.label}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'flex-end', flex: 1 },
  chip: { paddingVertical: 4, paddingHorizontal: 8, borderRadius: 6, backgroundColor: '#f0f0f0', marginLeft: 4, marginVertical: 2 },
  chipActive: { backgroundColor: '#2563EB' },
  text: { fontSize: 12, color: '#444', fontWeight: '500' },
  textActive: { color: '#FFFFFF', fontWeight: 'bold' }
});
